import React from "react";
import Drawer from "@mui/material/Drawer";

interface IPlacementWorksheetBottomPopupProps {
  open: boolean;
  onClose?: () => void;
}

export const PlacementWorksheetBottomPopup: React.FC<IPlacementWorksheetBottomPopupProps> = ({
  children,
  open,
  onClose,
}) => (
  <Drawer
    open={open}
    onClose={onClose}
    elevation={3}
    variant="persistent"
    anchor="bottom"
    PaperProps={{
      sx: {
        boxShadow: "0px -16px 32px rgba(26, 29, 32, 0.16)",
        borderTop: (theme) => `2px solid ${theme.palette.primary.dark}`,
      },
    }}
  >
    {children}
  </Drawer>
);
